import {
  type DynamicTableExcelOptions,
  downloadDynamicTablesAsExcel,
  importDynamicTableSheetsFromExcel,
} from '../../utils/dynamic-table-excel';
import ExcelImportToolbar from './ExcelImportToolbar';

type Props = {
  title: string;
  tables: DynamicTableExcelOptions[];
  disabled?: boolean;
  confirmImport?: boolean;
  onImport: (values: Record<string, string>[]) => void | Promise<void>;
};

export default function DynamicTablesExcelToolbar({
  title,
  tables,
  disabled = false,
  confirmImport = true,
  onImport,
}: Props) {
  if (tables.length === 0) return null;

  return (
    <ExcelImportToolbar
      title={title}
      disabled={disabled}
      confirmImport={confirmImport}
      onDownload={() => downloadDynamicTablesAsExcel({ title, tables })}
      readFile={async (file) => ({
        status: 'ready',
        values: await importDynamicTableSheetsFromExcel(file, { title, tables }),
      })}
      onImport={onImport}
    />
  );
}
